import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Menu, Bell, Search, LogOut, User, Key, ChevronDown } from 'lucide-react';
import useAuthStore from '../../stores/authStore';
import Avatar from '../common/Avatar';
import ChangePasswordModal from '../../pages/auth/ChangePasswordModal';
import './Header.css';

export default function Header({ onMenuToggle }) {
    const { user, logout } = useAuthStore();
    const navigate = useNavigate();
    const [showUserMenu, setShowUserMenu] = useState(false);
    const [showPasswordModal, setShowPasswordModal] = useState(false);
    const [notificationCount] = useState(3); // TODO: Get from API

    const handleLogout = async () => {
        await logout();
    };

    return (
        <>
            <header className="header">
                <div className="header-left">
                    <button className="header-menu-btn" onClick={onMenuToggle}>
                        <Menu size={24} />
                    </button>
                    <div className="header-search">
                        <Search size={18} className="header-search-icon" />
                        <input
                            type="text"
                            placeholder="Search..."
                            className="header-search-input"
                        />
                    </div>
                </div>

                <div className="header-right">
                    <button className="header-notification">
                        <Bell size={20} />
                        {notificationCount > 0 && (
                            <span className="notification-badge">{notificationCount}</span>
                        )}
                    </button>

                    <div className="header-user" onClick={() => setShowUserMenu(!showUserMenu)}>
                        <Avatar name={user?.fullName} size="sm" />
                        <div className="header-user-info">
                            <span className="header-user-name">{user?.fullName}</span>
                            <span className="header-user-role">{user?.role}</span>
                        </div>
                        <ChevronDown size={16} className={`header-user-arrow ${showUserMenu ? 'open' : ''}`} />

                        {showUserMenu && (
                            <div className="user-menu">
                                <button className="user-menu-item" onClick={() => {
                                    setShowUserMenu(false);
                                    navigate('/profile');
                                }}>
                                    <User size={16} />
                                    <span>My Profile</span>
                                </button>
                                <button className="user-menu-item" onClick={() => {
                                    setShowUserMenu(false);
                                    setShowPasswordModal(true);
                                }}>
                                    <Key size={16} />
                                    <span>Change Password</span>
                                </button>
                                <div className="user-menu-divider" />
                                <button className="user-menu-item logout" onClick={handleLogout}>
                                    <LogOut size={16} />
                                    <span>Logout</span>
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </header>

            <ChangePasswordModal
                isOpen={showPasswordModal}
                onClose={() => setShowPasswordModal(false)}
            />
        </>
    );
}

Header.propTypes = {
    onMenuToggle: PropTypes.func
};
